import { combineReducers } from "@reduxjs/toolkit";
import sportCourtReducer from "./sportCourtReducer";

export default combineReducers({
  sportCourtState: sportCourtReducer,
});
